import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { InputFileDirective } from 'src/app/directives/input-file.directive';
import { InputNumberDirective } from 'src/app/directives/input-number.directive';
import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { LoadingComponent } from './loading/loading.component';
import { PageLoadingComponent } from './page-loading/page-loading.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SkeletonLoadingComponent } from './skeleton-loading/skeleton-loading.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from 'src/app/directives/icon.module';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    IconModule,
  ],
  declarations: [
    LoadingComponent,
    PageLoadingComponent,
    PaginationComponent,
    InputFileDirective,
    InputNumberDirective,
    ConfirmModalComponent,
    SkeletonLoadingComponent,
    AutocompleteComponent,
  ],
  exports: [
    LoadingComponent,
    PageLoadingComponent,
    PaginationComponent,
    InputFileDirective,
    InputNumberDirective,
    MatButtonModule,
    ConfirmModalComponent,
    SkeletonLoadingComponent,
    AutocompleteComponent,
  ],
})
export class SharedModule {}
